import { gql } from "@apollo/client";

export const GET_ALL_PROMPTS = gql`
  query MyQuery {
    getAllPrompts {
      _id
      prompt
      created_at
      updated_at
    }
  }
`;

export const CREATE_CONVERSATION_MUTATION = gql`
  mutation CreateConversation($brandId: String!) {
    createConversation(brandId: $brandId) {
      _id
      brand_id
      created_at
      title
      updated_at
      working_messages {
        content
        role
      }
    }
  }
`;

export const ASK_VYRILL_QUERY = gql`
  query MyQuery(
    $brandId: String!
    $conversationId: String!
    $duration: String!
    $content: String!
    $role: String!
    $start_date: String
    $end_date: String
  ) {
    askVyrill(
      brandId: $brandId
      conversationId: $conversationId
      duration: $duration
      start_date: $start_date
      end_date: $end_date
      userMessage: { content: $content, role: $role }
    ) {
      _id
      content
      conversation_id
      end_date
      like
      role
      start_date
      question_id
      supporting_data {
        collection_source
        db_id
        end_ts
        source_doc
        source_doc_type
        start_ts
        thumbnail_url
        transcript_id_video_id
      }
      _id
    }
  }
`;

export const ASK_VYRILL_REGENRATE_RESPONSE = gql`
  query MyQuery(
    $conversationId: String!
    $questionId: String!
    $responseId: String!
  ) {
    regenerate(
      conversationId: $conversationId
      questionId: $questionId
      responseId: $responseId
    ) {
      _id
      content
      conversation_id
      end_date
      like
      role
      start_date
      supporting_data {
        collection_source
        db_id
        end_ts
        source_doc
        source_doc_type
        start_ts
        thumbnail_url
        transcript_id_video_id
      }
      _id
    }
  }
`;

// getting all conversation by brand
export const GET_CONVERSATIONS = gql`
  query GetConversations($brandId: String!) {
    getConversations(brandId: $brandId) {
      _id
      brand_id
      created_at
      title
      updated_at
      working_messages {
        content
        role
      }
    }
  }
`;

export const GET_MESSAGES_QUERY = gql`
  query MyQuery($conversationId: String!) {
    getMessages(conversationId: $conversationId) {
      _id
      content
      conversation_id
      end_date
      like
      role
      start_date
      supporting_data {
        collection_source
        db_id
        end_ts
        source_doc
        source_doc_type
        start_ts
        thumbnail_url
        transcript_id_video_id
      }
    }
  }
`;

export const UPDATE_CONVERSATION_MUTATION = gql`
  mutation updateConversation($conversationId: String!, $title: String!) {
    updateConversation(conversationId: $conversationId, title: $title) {
      _id
      brand_id
      created_at
      title
      updated_at
    }
  }
`;

export const GET_VIDEO_DETAILS = gql`
  query GetVideo($_id: ID!) {
    getVideo(queryVideo: { _id: $_id }) {
      _id
      thumbnail_url
      added_by_bm
      platform
      video_embedded_url
      title
      video_url
      tiktok_id
    }
  }
`;

export const DELETE_CONVERSATION_MUTATION = gql`
  mutation DeleteConversation($conversationId: String!) {
    deleteConversation(conversationId: $conversationId)
  }
`;

export const LIKE_MESSAGE_MUTATION = gql`
  mutation LikeMessage($like: Int!, $messageId: String!) {
    likeMessage(like: $like, messageId: $messageId) {
      _id
      content
      conversation_id
      end_date
      like
      role
      start_date
      supporting_data {
        collection_source
        db_id
        end_ts
        source_doc
        source_doc_type
        start_ts
        thumbnail_url
        transcript_id_video_id
      }
    }
  }
`;
